import type { ReactNode } from "react";
import styles from "./FilterResultCount.module.css";

type FilterResultCountProps = {
  count: number;
  // 세는 대상("데이터셋"·"세션")이다. 화면이 정한다.
  unitLabel: ReactNode;
  // 주변 여백은 배치하는 쪽이 정한다(레일 아래 · 도구 띠 안 등).
  className?: string;
};

/**
 * "검색 결과: N {단위}" 표기다. 조회 조건이 적용된 목록 화면이 함께 쓰는 결과 수 표기다.
 *
 * 문구·크기·개수 강조·색(accent)·live region 을 한 곳에 둔다. 어느 위치에서도 같은 파란 강조라
 * 화면마다 표기가 다르지 않다. 크기는 c6 body 스케일 토큰이라 옆의 다른 문구와 같은 줄에 맞는다.
 * 값은 서버 total 을 그대로 받는다. 개수를 세는 요청을 따로 보내는 화면은 없다.
 */
export function FilterResultCount({
  count,
  unitLabel,
  className,
}: FilterResultCountProps): ReactNode {
  const classes = [styles.resultCount, className].filter(Boolean).join(" ");
  return (
    <div className={classes} role="status">
      검색 결과: <strong>{count}</strong> {unitLabel}
    </div>
  );
}
